import { Link } from 'react-router-dom';

const footerLinks = {
  product: {
    title: '蔬菜分类',
    links: [
      { label: '叶菜类', href: '/categories' },
      { label: '根茎类', href: '/categories' },
      { label: '茄果类', href: '/categories' },
      { label: '菌菇类', href: '/categories' },
      { label: '豆类', href: '/categories' },
      { label: '瓜类', href: '/categories' },
    ],
  },
  about: {
    title: '关于我们',
    links: [
      { label: '品牌介绍', href: '/about' },
      { label: '口碑信誉', href: '/about' },
      { label: '联系我们', href: '/about' },
    ],
  },
  articles: {
    title: '健康资讯',
    links: [
      { label: '选菜指南', href: '/articles' },
      { label: '时令推荐', href: '/articles' },
      { label: '保鲜技巧', href: '/articles' },
      { label: '创意料理', href: '/articles' },
    ],
  },
  service: {
    title: '服务支持',
    links: [
      { label: '配送说明', href: '/about' },
      { label: '售后政策', href: '/about' },
      { label: '常见问题', href: '/about' },
      { label: '合作咨询', href: '/about' },
    ],
  },
};

export default function Footer() {
  return (
    <footer className="bg-secondary-50 border-t border-background-200/70">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-2 md:grid-cols-5 gap-8">
          <div className="col-span-2 md:col-span-1">
            <Link to="/" className="inline-block mb-4">
              <span className="text-xl font-heading font-bold text-primary-600">新有菜</span>
            </Link>
            <p className="text-sm text-foreground-500 leading-relaxed mb-4">
              从田间到餐桌
              <br />
              新鲜蔬菜直采直配
              <br />
              品质保障 · 每日送达
            </p>
            <div className="flex items-center gap-3">
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-100 hover:bg-primary-100 text-foreground-500 hover:text-primary-600 transition-colors cursor-pointer" aria-label="微信">
                <i className="ri-wechat-line"></i>
              </a>
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-100 hover:bg-primary-100 text-foreground-500 hover:text-primary-600 transition-colors cursor-pointer" aria-label="微博">
                <i className="ri-weibo-line"></i>
              </a>
            </div>
          </div>

          {Object.values(footerLinks).map((section) => (
            <div key={section.title}>
              <h4 className="text-sm font-semibold text-foreground-900 mb-4">
                {section.title}
              </h4>
              <ul className="space-y-2.5">
                {section.links.map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.href}
                      className="text-sm text-foreground-500 hover:text-primary-600 transition-colors cursor-pointer"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-12 pt-8 border-t border-background-200/70 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-400">
            &copy; {new Date().getFullYear()} 新有菜 版权所有 | 新鲜蔬菜直供平台
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-xs text-foreground-400 hover:text-primary-600 transition-colors cursor-pointer">隐私政策</a>
            <a href="#" className="text-xs text-foreground-400 hover:text-primary-600 transition-colors cursor-pointer">用户协议</a>
            <a href="#" className="text-xs text-foreground-400 hover:text-primary-600 transition-colors cursor-pointer" rel="nofollow">ICP备案号</a>
          </div>
        </div>
      </div>
    </footer>
  );
}